var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrapper"},[_c('div',{staticClass:"resource-container"},[_c('div',{staticClass:"title"},[_vm._v("公司资源")]),_c('p',{staticClass:"resource-desc"},[_vm._v(" 公司拥有丰富的产研资源和强大的研发应用能力。覆盖了一支“院士、千人学者、973项目首席”领衔的优秀学术团队；联合了10多个国家重点实验室、国家级工程研究中心、技术研究中心及联合实验室；拥有实体汽车智能工厂和8大智能制造实验室等真实完备的产品研发和验证基地；具备十年以上的工艺、工装、仿真及连接技术分析专业团队；已申请受理智能制造发明专利101项、软著8项等。 ")])])])
}]

export { render, staticRenderFns }